import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useCreateBudgetPlanGoal = (budgetPlanId, onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: `/budget-plans/${budgetPlanId}/goals`,
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["create-budget-plan-goal", budgetPlanId],
    mutationFn: (goal) => mutationFn({ data: goal }),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["budget-plan"] });
      onSuccess?.(data, variables);
    },
  });
};
